export const MD_LOG_ACTION_EXPORT = 'SEND_TO_EXPORT';
export const MD_LOG_ACTION_SAVE = 'SAVED';
